import { createFileRoute } from "@tanstack/react-router";
import { OmOsPage, omosHead } from "@/pages/OmOsPage";

export const Route = createFileRoute("/om-os")({
  head: () => omosHead("da"),
  component: () => <OmOsPage locale="da" />,
});
